import React from "react";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import { DialogTitle } from "@mui/material";

const Header = styled(DialogTitle)`
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px 12px 24px;
`;

const Title = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0px;
  vertical-align: middle;
`;

export default function ModalHeader({ icon, title, onClose }) {
  return (
    <div style={{ backgroundColor: "#1F2735" }}>
      <Header>
        <div style={{
          display: "flex", alignItems: "center", gap: "12px", color: "#A5E0FF"
        }}>
          {icon}
          <Title>{title}</Title>
        </div>
        <IconButton onClick={onClose} color="inherit" size="small" sx={{ padding: "0px" }}>
          <CloseIcon sx={{ color: "#A1A5AC" }} />
        </IconButton>
      </Header>
    </div>
  );
}
